import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const SUPABASE_URL = 'https://cbzuhluoxeifnpexwjad.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNienVobHVveGVpZm5wZXh3amFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzMjY2MDUsImV4cCI6MjA2NjkwMjYwNX0.XbTyYVBfLJrsMaq-GwjggVY2bHF7VZyXud59EA10xhw';

// Initialize Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    detectSessionInUrl: true,
    autoRefreshToken: true,
    persistSession: true,
  },
});
